import {
  mapTransactionFlagToResource,
  mapUserTransactionReasonToResource,
} from '@/features/payouts/transaction-mappers'
import { type ApprovedTransaction } from './ApprovedTransaction'
import { type PendingTransaction } from './PendingTransaction'

/**
 * Maps pending transactions to CSV rows, header first.
 */
export function mapPendingTransactionsToCsv(
  transactions: PendingTransaction[],
) {
  const header = [
    'Job ID',
    'Transaction Short ID',
    'Recipient User ID',
    'Amount',
    'Workspace ID',
    'Date Created',
    'Date Transacted',
    'Reason',
    'Flags',
  ]

  const csvData = transactions.map((tx) => [
    tx.jobId ?? '',
    tx.shortId,
    tx.recipient.publicId,
    tx.amount.toString(),
    tx.workspace.id,
    tx.createdAt.toLocaleDateString(),
    tx.transactedAt.toLocaleDateString(),
    tx.reason ? mapUserTransactionReasonToResource(tx.reason) : '',
    tx.flags.map(mapTransactionFlagToResource).join(', '),
  ])

  return [header, ...csvData]
}

/**
 * Maps approved transactions to CSV rows, header first.
 */
export function mapApprovedTransactionsToCsv(
  transactions: ApprovedTransaction[],
) {
  const header = [
    'Job ID',
    'Transaction Short ID',
    'Recipient User ID',
    'Amount',
    'Workspace ID',
    'Date Created',
    'Date Transacted',
    'Date Approved',
    'Approved By User ID',
    'Reason',
    'Flags',
  ]

  const csvData = transactions.map((tx) => [
    tx.jobId ?? '',
    tx.shortId,
    tx.recipient.publicId,
    tx.amount.toString(),
    tx.workspace.id,
    tx.createdAt.toLocaleDateString(),
    tx.transactedAt.toLocaleDateString(),
    tx.approvedAt.toLocaleDateString(),
    tx.approvedBy.publicId,
    tx.reason ? mapUserTransactionReasonToResource(tx.reason) : '',
    tx.flags.map(mapTransactionFlagToResource).join(', '),
  ])

  return [header, ...csvData]
}
